var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('div',{staticClass:"header"},[_vm._v("This is sidebar secetion")])])}
var staticRenderFns = []

export { render, staticRenderFns }